import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('workflowdisplayname_fields'),
    fieldNameCol: defineMessage('field_name'),
    fieldTypeCol: defineMessage('field_type'),
    fieldStateCol: defineMessage('field_state'),
    hiddenFieldState: defineMessage('hidden'),
    readOnlyFieldState: defineMessage('readonly'),
    editableFieldState: defineMessage('editable'),
    mandatoryFieldState: defineMessage('mandatory'),
    headerFieldsTitle: defineMessage('header_fields'),
    itemsFieldsTitle: defineMessage('items_fields'),
    expensesFieldsTitle: defineMessage('expenses_fields'),
    applyLineFieldsTitle: defineMessage('applied_to_fields'),
    creditLineFieldsTitle: defineMessage('credits_applied_fields'),
    addressLineFieldsTitle: defineMessage('address_line_fields'),
    attachmentsFieldsTitle: defineMessage('attachments'),
    doneButton: defineMessage('done'),
    unitPriceFieldName: defineMessage('rate'),
    resetToDefaultButton: defineMessage('reset_to_default'),
};
